import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_CONFIG = {
  campaignManagerBetaUrl: 'https://admanager.acast.com',
  cookiePolicyUrl: 'https://www.acast.com/cookies',
  insightsUrl: 'https://insights.acast.com',
  revenueUrl: 'https://revenue.acast.com',
  dashboardUrl: 'https://dashboard.acast.com',
  graphqlApiUrl: 'https://graphql-api.prod.vision.acast.com',
  financeUrl: 'https://finance.acast.com',
  helpUrl: 'https://learn.acast.com',
  impersonationApiUrl: 'https://impersonation-api.acast.com',
  openUrl: 'https://open.acast.com',
  privacyPolicyUrl: 'https://www.acast.com/privacy-policy',
  termsOfServiceUrl: 'https://www.acast.com/legal',
  profileUrl: 'https://profile.acast.com',
  rolesApiUrl: 'https://roles-api.acast.com',
  userManagementUrl: 'https://user-management.acast.com',
  plusUrl: 'https://plus-manage.acast.com',
  sponsorshipManagerUrl: 'https://sponsorships.acast.com/',
  intercomAppId: 'ayi0335i',
  selfServeUrl: 'https://selfserve.acast.com/',
  supportEmail: 'support@acast.com',
  auth0Audience: 'https://acast.eu.auth0.com/api/v2/',
  auth0Domain: 'login.acast.com',
  auth0ClientId: '3gbIaD2F3GddNcvPCJLQxsLWcgrSYBSF'
};
export function getConfig(env = 'production') {
  const config = Object.assign({}, DEFAULT_CONFIG);
  if (env === 'development') {
    config.campaignManagerBetaUrl = 'https://cammy.dev.monet.acast.cloud';
    config.dashboardUrl = 'https://dashboard.dev.vision.acast.cloud';
    config.financeUrl = 'https://finance-systemtest.acast.com';
    config.graphqlApiUrl = 'https://graphql-api.dev.vision.acast.cloud';
    config.impersonationApiUrl = 'https://impersonation-api.dev.vision.acast.cloud';
    config.insightsUrl = 'https://insights.dev.vision.acast.cloud';
    config.openUrl = 'https://open.dev.satellite.acast.cloud';
    config.profileUrl = 'https://profile.dev.vision.acast.cloud';
    config.revenueUrl = 'https://revenue.dev.fortune.acast.cloud';
    config.rolesApiUrl = 'https://roles-api.acast.cloud';
    config.userManagementUrl = 'https://user-management.dev.vision.acast.cloud';
    config.auth0Audience = 'https://acast-systemtest.eu.auth0.com/api/v2/';
    config.plusUrl = 'https://plus-manage.dev.ateam.acast.cloud';
    config.intercomAppId = 'qg6rsrbc';
    config.selfServeUrl = 'https://selfie.dev.mercury.acast.cloud/';
    config.sponsorshipManagerUrl = 'https://sponsorships.dev.nemo.acast.cloud/';
    config.auth0Domain = 'login.dev.acast.cloud';
    config.auth0ClientId = '0Ka871LxAtRXwuTl0hoHnrNSePTA5gAR';
  }
  return config;
}
export const AppConfigContext = /*#__PURE__*/createContext(null);
AppConfigContext.displayName = 'AppConfigContext';
export function AppConfig({
  config,
  children
}) {
  return /*#__PURE__*/_jsx(AppConfigContext.Provider, {
    value: config,
    children: children
  });
}
export function useAppConfig() {
  const context = useContext(AppConfigContext);
  if (!context) {
    throw new Error('useAppConfig() may be used only in the context of a <AppConfig> component.');
  }
  return context;
}